import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useDocumentTitle from '../../../components/useDocumentTitle';
import { client } from "../../../config/ipfsConfig";
import { getCollectionListbyWalletAddress } from '../../../hooks/Collectionhook';
import { getUserByAddress } from '../../../hooks/User';
import { ethers, getBigInt } from 'ethers';
import { MdDelete, MdKeyboardArrowUp, MdOutlineKeyboardArrowDown } from 'react-icons/md';
import Papa from 'papaparse';
import { FaCirclePlus } from "react-icons/fa6";
import { contractAddress } from '../../../config/BackendUrl';
import { ToastContainer, toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { collectionABI } from '../../../config/ABIs/CollectionABI';
import { ContractABI } from '../../../config/ABIs/ContractABI';
import useFullPageLoader from '../../../hooks/useFullPageLoader';
import { deleteNFTDraft, getNFTDraftsById, updateNFTDraft } from '../../../hooks/DraftHook';
import { getDataFromURI } from '../../../hooks/Tokenhook';
import { createNFT, getNFT, updateNFT } from '../../../hooks/NFTHook';

const DraftNFTDetails = () => {
    useDocumentTitle('Mint');
    const [fileUrl, setFileUrl] = useState(null);
    const [type, setType] = useState(null);
    const [formInput, updateFormInput] = useState({});
    const [collection, setCollection] = useState([]);
    const walletAddress = localStorage.getItem("WalletAddress");
    const [attributes, setAttributes] = useState([]);
    const [newAttribute, setNewAttribute] = useState({ trait_type: '', value: '' });
    const [propertiesFile, setPropertiesFile] = useState(null);
    const [csvFileName, setCsvFileName] = useState(null);
    const [userData, setUserData] = useState({});
    const [show, setShow] = useState(false);
    const [collectionshow, setCollectionshow] = useState(false);
    const [isSelected, setIsSelected] = useState(false);
    // const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [selectObj, setSelectObj] = useState({ logo: "img/logos/dtoc.png", "name": "DtoC", symbol: "D2C", contractAddress: contractAddress })
    const route = useNavigate();
    const PROVIDER = useSelector((state) => state.valueFromHeader);
    const [nft, setNft] = useState();
    const { id } = useParams();
    const userId = localStorage.getItem("userId");

    useEffect(() => {
        getNFT(id).then((data) => {
            if (data.success) {
                console.log("data", data.data);

                setNft(data.data)
                updateFormInput(data.data)
                const Query = { contractAddress: data.data.contractAddress };
                getCollectionListbyWalletAddress(data.data.contractAddress).then((data) => {
                    console.log("Collection Details", data.data);

                    if (data.success) {
                        const Collect = data.data[0]
                        // setMyArray(newArray);
                        if (Collect?.contractAddress !== contractAddress) {
                            setSelectObj(Collect)
                        }
                    }
                })

            }
        })
    }, [id])

    async function handleChange(e) {
        updateFormInput({
            ...formInput,
            [e.target.name]: e.target.value,
        })
    }


    useEffect(() => {
        const Query = { ownerAddress: walletAddress };
        getCollectionListbyWalletAddress(Query).then((data) => {
            if (data.status === 201) {
                const Collect = data.data
                const newArray = Collect.map((item, i) => {
                    return { ...item, isActive: false }; // Update object at specific index
                });
                // setMyArray(newArray);
                setCollection(newArray)
            }
        })
    }, [walletAddress])

    useEffect(() => {
        window.scrollTo(0, 0);
        if (walletAddress)
            getUserByAddress(walletAddress).then((data) => {
                setUserData(data.user);
            })
    }, [walletAddress]);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewAttribute({ ...newAttribute, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (newAttribute.trait_type !== "" && newAttribute.value !== "") {
            setAttributes([...attributes, newAttribute]);
            setNewAttribute({ trait_type: '', value: '' });
        }
    };

    const onJsonChange = (event) => {
        const uploadedFile = event.target.files[0];
        setCsvFileName(event.target.files[0].name)
        // setFile(uploadedFile);
        if (uploadedFile) {
            const reader = new FileReader();
            reader.onload = (event) => {
                const csvData = event.target.result;
                // Parse the CSV data using papaparse
                const parsedData = Papa.parse(csvData, { header: true }); // Adjust options as needed
                setPropertiesFile(parsedData.data);
            };
            reader.readAsText(uploadedFile);
        } else {
            console.error("Please select a CSV file");
        }
    };

    const handleDelete = (index) => {
        const newAttributes = attributes.filter((_, i) => i !== index);
        setAttributes(newAttributes);
    };

    function updateStateByIndex(index, newState, obj, stateValue) {
        setIsSelected(stateValue)
        setCollectionshow(false)
        setSelectObj(obj)
        getCollectionListbyWalletAddress(walletAddress).then((data) => {
            const Collect = data.data
            const GetCollection = Collect.map((item, i) => {
                return { ...item, isActive: false }; // Update object at specific index
            });
            // setMyArray(newArray);
            // setCollection(newArray)
            if (index) {
                const newArray = GetCollection.filter((data, i) => i !== index).map((item, i) => {
                    if (i === index) {
                        return { ...item, isActive: newState }; // Update object at specific index
                    }
                    if (newState === true) {
                        if (i !== index) {
                            return { ...item, isActive: false };
                        }
                    }
                    else {
                        if (i !== index) {
                            return { ...item, isActive: true };
                        }
                    }
                    return item; // Keep other elements unchanged
                });
                setCollection(newArray); // Assuming 'setMyArray' is a state setter function
                // const FilCollectioin = collection.filter((data, i) => i === index)
                // setSelectCollection(FilCollectioin[0])
            }
        })
    }
    console.log("", formInput);

    const CreateMint = async () => {
        // showLoader();
        if (!walletAddress) {
            toast.error("Please Connect Wallet First")
        }
        else {
            if (selectObj.contractAddress !== contractAddress) {
                await callMyFunction();
            }
            else {
                console.log("iis Slecf", isSelected);

                if (formInput.price?.trim() === '') {
                    // setUsernameError('Username is required');
                    toast.error('Price is required!');
                    return; // Stop execution if validation fails
                }
                else {

                    await MintinPlateform();
                }
            }
        }
    };

    const callMyFunction = async () => {
        console.log("for Collecton");

        try {
            let url;
            let dataObject = {
                title: formInput.title,
                assetType: formInput.type,
                desc: formInput.description,
                category: formInput.category,
                imageUri: formInput.imageUri,
            };

            if (attributes.length !== 0) {
                dataObject.attributes = formInput.attributes;
            }

            if (propertiesFile !== null) {
                dataObject.properties = formInput.propertiesFile;
            }
            console.log("step 1 => add all Data", dataObject, formInput);

            try {
                // Convert the object to a JSON string
                const dataBuffer = Buffer.from(JSON.stringify(dataObject));

                // Add the JSON buffer to IPFS
                const added = await client.add(dataBuffer);

                // Generate the IPFS URL
                url = `https://dtoc.infura-ipfs.io/ipfs/${added.path}`;
                console.log("step 2 => convert dataObject to ipfs url", url);
            } catch (error) {
                console.error("Error adding data to IPFS:", error);
            }
            // const provider = new BrowserProvider(window.ethereum);
            const wallet = await PROVIDER.getSigner();
            console.log("step 3 => proovider and wallet", selectObj.contractAddress, wallet, collectionABI);

            const contracts = new ethers.Contract(
                selectObj.contractAddress,
                collectionABI,
                wallet
            );

            const royaltyFraction = formInput.royaltyFraction;
            console.log("step 4 => contracts and body", contracts, walletAddress,
                url,
                royaltyFraction);
            const test = await contracts.safeMint(
                walletAddress,
                url,
                royaltyFraction
            );

            const receipt = await test.wait();
            console.log("step 5 => receipt", receipt);

            if (receipt) {
                const transferEventSignatures = ethers.keccak256(ethers.toUtf8Bytes("Transfer(address,address,uint256)"));
                // Filter logs for Transfer events
                const logs = receipt.logs.filter((log) => log.topics[0] === transferEventSignatures);
                console.log("step 6 => logs", logs);

                let tokenId, from, to, transactionHash;

                if (logs.length > 0) {
                    logs.forEach((log) => {
                        try {
                            const rawFrom = log.topics[1];
                            const rawTo = log.topics[2];
                            // Decode the 'from' and 'to' addresses, handling zero address scenarios
                            from = rawFrom !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawFrom.slice(-40)) : "Minting (no from)";
                            to = rawTo !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawTo.slice(-40)) : "Burning (no to)";

                            // Extract tokenId directly from topics[3]
                            tokenId = getBigInt(log.topics[3]).toString(); // Convert BigInt to string
                            transactionHash = log.transactionHash;

                            const NFTbody = {
                                tokenUri: url,
                                imageUri: formInput.imageUri,
                                tokenId: tokenId,
                                title: formInput.title,
                                description: formInput.desc,
                                walletAddress: walletAddress,
                                royaltyFraction: formInput.royaltyFraction,
                                contractAddress: selectObj.contractAddress,
                                category: formInput.category,
                                assetType: formInput.assetType,
                                transactionHash: transactionHash,
                                listed: true,
                                draft: false,
                                type: "Direct Mint",
                                creator: {
                                    userId: userId,
                                    walletAddress: walletAddress
                                },
                                currentOwner: {
                                    userId: userId,
                                    walletAddress: walletAddress
                                },
                                activity: [{
                                    event: "Minted",
                                    price: "0",
                                    from: 0x0000000000000000000000000000000000000000,
                                    to: to
                                }]
                            }
                            console.log("step 8 => logs", NFTbody, formInput);

                            updateNFT(nft._id, NFTbody).then(async (data) => {
                                if (data.success) {
                                    console.log("step 9 => Cfreate NFT", data, data.data);

                                    toast.success("Transaction successful. Created NFT successfully !!!")
                                    setTimeout(() => {
                                        route('/marketplace');
                                    }, 2000);
                                }
                            })
                        } catch (error) {
                            console.error("Error decoding log:", log, error);
                        }
                    });
                } else {
                    console.error("Unable to find Transfer event in raw logs.");
                }
            }
        } catch (error) {
            console.error("Error calling function:", error);
        }
    };

    const MintinPlateform = async () => {
        try {
            let url;
            let dataObject = {
                title: formInput.title,
                assetType: formInput.type,
                desc: formInput.description,
                price: formInput.price,
                category: formInput.category,
                imageUri: formInput.imageUri,
            };

            if (attributes.length !== 0) {
                dataObject.attributes = formInput.attributes;
            }

            if (propertiesFile !== null) {
                dataObject.properties = formInput.propertiesFile;
            }
            console.log("step 1 => add all Data", dataObject, formInput);

            try {
                // Convert the object to a JSON string
                const dataBuffer = Buffer.from(JSON.stringify(dataObject));

                // Add the JSON buffer to IPFS
                const added = await client.add(dataBuffer);

                // Generate the IPFS URL
                url = `https://dtoc.infura-ipfs.io/ipfs/${added.path}`;
                console.log("step 2 => convert dataObject to ipfs url", url);
            } catch (error) {
                console.error("Error adding data to IPFS:", error);
            }
            const wallet = await PROVIDER.getSigner();
            const contracts = new ethers.Contract(
                contractAddress,
                ContractABI,
                wallet
            );
            const price = ethers.parseEther(formInput.price);
            const test = await contracts.createToken(
                url,
                price
            );

            const receipt = await test.wait();

            if (receipt) {
                const transferEventSignatures = ethers.keccak256(ethers.toUtf8Bytes("Transfer(address,address,uint256)"));
                // Filter logs for Transfer events
                const logs = receipt.logs.filter((log) => log.topics[0] === transferEventSignatures);
                console.log("step 6 => logs", logs);

                let tokenId, from, to, transactionHash;

                if (logs.length > 0) {
                    logs.forEach((log) => {
                        try {
                            const rawFrom = log.topics[1];
                            const rawTo = log.topics[2];
                            // Decode the 'from' and 'to' addresses, handling zero address scenarios
                            from = rawFrom !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawFrom.slice(-40)) : "Minting (no from)";
                            console.log("step 7.1 -> from:", from);

                            to = rawTo !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawTo.slice(-40)) : "Burning (no to)";
                            console.log("step 7.2 -> to:", to);

                            // Extract tokenId directly from topics[3]
                            tokenId = getBigInt(log.topics[3]).toString(); // Convert BigInt to string
                            transactionHash = log.transactionHash;
                            console.log("step 7.3 -> transactionHash:", transactionHash);

                            console.log("step 7 -> Token ID, from, to, transaction hash:", tokenId, from, to, transactionHash);
                            const NFTbody = {
                                tokenUri: url,
                                imageUri: formInput.imageUri,
                                tokenId: tokenId,
                                title: formInput.title,
                                description: formInput.desc,
                                walletAddress: walletAddress,
                                price: formInput.price,
                                contractAddress: selectObj.contractAddress,
                                category: formInput.category,
                                assetType: formInput.assetType,
                                transactionHash: transactionHash,
                                listed: true,
                                draft: false,
                                type: "Direct Mint",
                                creator: {
                                    userId: userId,
                                    walletAddress: walletAddress
                                },
                                currentOwner: {
                                    userId: userId,
                                    walletAddress: walletAddress
                                },
                                activity: [{
                                    event: "Minted",
                                    price: formInput.price,
                                    from: 0x0000000000000000000000000000000000000000,
                                    to: to
                                }]
                            }
                            console.log("step 8 => logs", NFTbody, formInput);

                            updateNFT(nft._id, NFTbody).then(async (data) => {
                                if (data.success) {
                                    console.log("step 9 => Cfreate NFT", data, data.data);

                                    toast.success("Transaction successful. Created NFT successfully !!!")
                                    setTimeout(() => {
                                        route('/marketplace');
                                    }, 2000);
                                }
                            })
                        } catch (error) {
                            console.error("Error decoding log:", log, error);
                        }
                    });
                } else {
                    console.error("Unable to find Transfer event in raw logs.");
                }
            }
        } catch (error) {
            console.error("Error calling function:", error);
        }
    };

    console.log("body", formInput, selectObj, collection);

    const DraftUpdate = async () => {
        // showLoader();
        if (!walletAddress) {
            toast.error("Please Connect Wallet First !!!")
        }
        else if (!userData._id) {
            toast.error("Please Create Profile First !!!")
        }
        else {
            // const { ethers } = require("ethers");
            let url;
            let dataObject = {
                title: formInput.title,
                assetType: formInput.type,
                desc: formInput.description,
                category: formInput.category,
                imageUri: formInput.imageUri,
            };

            if (attributes.length !== 0) {
                dataObject.attributes = formInput.attributes;
            }

            if (propertiesFile !== null) {
                dataObject.properties = formInput.propertiesFile;
            }
            console.log("step 1 => add all Data", dataObject, formInput);

            try {
                // Convert the object to a JSON string
                const dataBuffer = Buffer.from(JSON.stringify(dataObject));

                // Add the JSON buffer to IPFS
                const added = await client.add(dataBuffer);

                // Generate the IPFS URL
                url = `https://dtoc.infura-ipfs.io/ipfs/${added.path}`;
                console.log("step 2 => convert dataObject to ipfs url", url);
            } catch (error) {
                console.error("Error adding data to IPFS:", error);
            }

            const NFTbody = {
                contractAddress: selectObj.contractAddress,
                tokenUri: url,
                title: formInput.title,
                description: formInput.desc,
                walletAddress: walletAddress,
                attributes: attributes,
                royaltyFraction: formInput.royaltyFraction ? formInput.royaltyFraction * 100 : null,
                price: formInput.price,
                category: formInput.category,
                type: "Direct Mint",

            }
            console.log("body", formInput);

            updateNFT(nft._id, NFTbody).then((res) => {
                if (res.status === 201) {
                    toast.success("Update Draft NFT successfully !!!")
                    // Navigate('/profile')
                    setTimeout(() => {
                        route('/marketplace');
                        // hideLoader();
                    }, 2000);

                }
                else if (res.status === 400) {
                    toast.error(res.message);
                }
            })
        }
    };
    const DraftDelete = async () => {
        // showLoader();
        if (!walletAddress) {
            toast.error("Please Connect Wallet First !!!")
        }
        else if (!userData._id) {
            toast.error("Please Create Profile First !!!")
        }
        else {
            // const { ethers } = require("ethers");

            deleteNFTDraft(nft._id).then((res) => {
                if (res.status === 201) {
                    toast.success("Delete Draft NFT successfully !!!")
                    // Navigate('/profile')
                    setTimeout(() => {
                        route('/marketplace');
                        // hideLoader();
                    }, 2000);

                }
                else if (res.status === 400) {
                    toast.error(res.message);
                }
            })
        }
    };

    return (
        <div>
            {/* <Header /> */}
            <div className="container" >
                <div className="box in__upload mt-40 mb-120">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="left__part space-y-40 md:mb-20 upload_file">
                                <div className="space-y-20">
                                    {nft?.assetType?.split('/')[0] === "image" ?

                                        <img src={nft?.imageUri} alt="" />

                                        :
                                        <video
                                            src={nft?.imageUri} autoPlay muted loop>
                                        </video>

                                    }
                                    {/* <h5>Drag and drop your file</h5>
                                    <p className="color_text">
                                        PNG, GIF, WEBP, MP4 or MP3. Max 100mb.
                                    </p> */}
                                </div>
                                {/* <div className="space-y-20">
                                    <p className="color_text">or choose a file</p>
                                    <Link to="#" className="btn btn-white">
                                        Browse files
                                    </Link>
                                    <input type="file" onChange={onChange} />
                                </div> */}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="form-group space-y-10">
                                <div className="space-y-20">
                                    <div className='space-y-10 colletion_ui'>
                                        <span className="variationInput">Choose collection</span>
                                        <div className="d-flex flex-column flex-md-row p-2">
                                            <div className={"isSelected_collection d-flex justify-content-between"} onClick={() => setCollectionshow(!collectionshow)}>
                                                <div className='d-flex justify-content-start' >
                                                    <img
                                                        src={selectObj?.logo}
                                                        alt="Dtoc_icon"
                                                    />
                                                    <div>
                                                        <div>
                                                            <span className="ml-10">
                                                                {selectObj?.name}
                                                            </span>

                                                        </div>
                                                        <div>
                                                            <p className="ml-10">
                                                                {selectObj?.symbol}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    {collectionshow ?
                                                        <MdKeyboardArrowUp size={32} onClick={() => setCollectionshow(false)} /> :
                                                        <MdOutlineKeyboardArrowDown size={32} onClick={() => setCollectionshow(true)} />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        {collectionshow &&
                                            <div className='colletion_ui_data'>

                                                <div className="d-flex flex-column flex-md-row p-2">
                                                    <div
                                                        className={` choose_collection  d-flex justify-content-start`}
                                                    // onClick={() => updateStateByIndex(null, true, { logo: "img/icons/raroin_icon.svg", name: "DtoC", symbol: "D2C" }, false)}
                                                    >
                                                        <img
                                                            src={selectObj.logo}
                                                            alt="Dtoc_icon"
                                                        />
                                                        <div>
                                                            <div>
                                                                <span className=" ml-10">
                                                                    {selectObj.name}
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <p className=" ml-10">
                                                                    {selectObj.symbol}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* {collection.length !== 0 &&
                                                    collection.map((data, i) => (
                                                        <div className="d-flex flex-column flex-md-row  p-2">
                                                            <div className={`${data.isActive ? "isSelected_collection" : "choose_collection "}  d-flex justify-content-start`} onClick={() => updateStateByIndex(i, true, data, true)}>
                                                                <img
                                                                    src={data !== null ? data?.logo : `img/logos/dtoc.png`}
                                                                    alt="Dtoc_icon"
                                                                />
                                                                <div>
                                                                    <div>
                                                                        <span className=" ml-10 d-flex">
                                                                            {data !== null && data?.name}
                                                                        </span>
                                                                    </div>
                                                                    <div>
                                                                        <span className=" ml-10">
                                                                            {data !== null && data.symbol}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                } */}
                                                {/* <div className="d-flex flex-column flex-md-row p-2">
                                                    <Link to="/collectionAdd" className="choose_collection d-flex justify-content-start">
                                                        <FaCirclePlus color='black' size="50" />
                                                        <div className='align-items-center '>
                                                            <div>
                                                                <span className=" ml-10">
                                                                    Create
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <p className=" ml-10">
                                                                    ERC-721
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div> */}
                                            </div>
                                        }
                                        {/* } */}
                                    </div>
                                    {/* </div> */}
                                    <div className="space-y-10">
                                        <span className="nameInput">Title</span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="e. g. `Dtoc design art`"
                                            name='title'
                                            onChange={handleChange}
                                            defaultValue={formInput ? formInput.title : "Title"}
                                        />
                                    </div>
                                    {nft?.contractAddress === contractAddress ?
                                        <div className="space-y-10">
                                            <span className="nameInput">
                                                Price
                                                {/* <span className="color_text">(optional) </span> */}
                                            </span>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Price"
                                                name='price'
                                                onChange={handleChange}
                                                defaultValue={formInput ? formInput.price : "Price"}

                                            />
                                            {/* {priceError && <div style={{ color: 'red' }}>{priceError}</div>} */}
                                        </div>
                                        // {
                                        //     selectObj.name !== "DtoC" &&
                                        :
                                        <div className="space-y-10">
                                            <span className="nameInput">
                                                Royalty
                                                {/* <span className="color_text">(optional) </span> */}
                                            </span>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder={formInput ? formInput.royaltyFraction / 100 : "Royalty"}
                                                name='royaltyFraction'
                                                onChange={(e) =>
                                                    updateFormInput({
                                                        ...formInput,
                                                        royaltyFraction: e.target.value,
                                                    })}
                                                // value={formInput ? formInput.royaltyFraction / 100 : "Royalty"}
                                                min="0" // Prevents entering negative numbers
                                                max="100" // Prevents entering numbers greater than 100
                                            // step="0.01" // Optional: Allows decimal numbers
                                            />
                                        </div>
                                    }
                                    {/* // } */}
                                    <div className="space-y-10">
                                        <span className="nameInput">
                                            Description
                                            {/* <span className="color_text">(optional) </span> */}
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Description"
                                            name='description'
                                            onChange={handleChange}
                                            defaultValue={formInput ? formInput.description : "Description"}

                                        />
                                    </div>
                                    <div className='space-y-10'>
                                        <span className="variationInput">Category</span>
                                        <select
                                            className="form-select custom-select" style={{ height: "auto" }}
                                            aria-label="Default select example" name="category" onChange={handleChange}>
                                            <option className="">{formInput ? formInput.category : "select a category"}</option>
                                            <option className="" value="Art">
                                                Art
                                            </option>
                                            <option className="" value="Graphics">
                                                Graphics
                                            </option>
                                            <option className="" value="Video">
                                                Video
                                            </option>
                                            <option className="" value="others">
                                                others
                                            </option>
                                        </select>
                                    </div>
                                    {show ?
                                        <div className='space-y-10'>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <h4>
                                                    Attribute
                                                </h4>
                                                <div>
                                                    <button
                                                        // to="item-details"
                                                        className="btn btn-grad space-y-10 mx-10
					btn_create"
                                                        onClick={() => setShow(false)}
                                                    >
                                                        Close
                                                    </button>
                                                    {/* <button
                            // to="item-details"
                            className="btn btn-grad space-y-10
					btn_create"
                            onClick={handleSubmit}
                          >
                            Add
                          </button> */}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-5">
                                                    <span className="nameInput">
                                                        Trait Type
                                                        {/* <span className="color_text">(optional) </span> */}
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Trait Type"
                                                        name="trait_type"
                                                        value={newAttribute.trait_type}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                <div className="col-lg-5">
                                                    <span className="nameInput">
                                                        Value
                                                        {/* <span className="color_text">(optional) </span> */}
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="value"
                                                        placeholder="Value"
                                                        value={newAttribute.value}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                <div className="col-lg-2" style={{ marginTop: "auto" }}>
                                                    <button
                                                        // to="item-details"
                                                        className="btn btn-grad space-y-10
					btn_create"
                                                        style={{ padding: "5px 10px" }}
                                                        onClick={handleSubmit}
                                                    >
                                                        Add
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        : <button
                                            className="btn btn-grad space-y-10 btn_create"
                                            onClick={() => setShow(true)}
                                        >
                                            Add Attribute
                                        </button>}
                                    {attributes.length !== 0 &&
                                        <>
                                            <p className="my-3">Attributes:</p>
                                            <div className="table-responsive">
                                                <table
                                                    id="user-list-table"
                                                    className="table table-hover"
                                                    role="grid"
                                                    data-toggle="data-table"
                                                >
                                                    <thead>
                                                        <tr className="ligth">
                                                            <th className="text-center">SNo.</th>
                                                            <th className="text-center">Trait Type</th>
                                                            <th className="text-center">Value</th>
                                                            <th className="text-center">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {attributes.map((attr, i) => {
                                                            return (
                                                                <tr key={i}>
                                                                    <td className="text-center">{i + 1}</td>
                                                                    <td className="text-center">{attr.trait_type}</td>
                                                                    <td className="text-center">{attr.value}</td>
                                                                    <td className="text-center" onClick={() => handleDelete(i)} > <MdDelete color="red" /> </td>

                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    }
                                    <div className="space-y-10 upload_file">
                                        <button
                                            // to="item-details"
                                            className="btn btn-grad
					btn_create"
                                            onClick={CreateMint}
                                        >
                                            Upload Properties File
                                        </button>
                                        <input type="file" accept=".csv" onChange={onJsonChange} />
                                    </div>
                                    {csvFileName}
                                </div>
                            </div>

                            <p></p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="fixed_row bottom-0 left-0 right-0">
                <div className="container">
                    <div className="row content justify-content-between mb-20_reset">
                        <div className="col-md-auto col-12 mb-20">

                        </div>
                        <div className="col-md-auto col-12 mb-20 space-x-10">
                            <button
                                className="btn btn-grad
					btn_create"
                                onClick={DraftUpdate}
                            >
                                Update Draft Mint
                            </button>
                            {/* <button
                                className="btn btn-grad
					btn_create"
                                onClick={DraftDelete}
                            >
                                Delete Draft NFT
                            </button> */}
                            <button
                                className="btn btn-grad
					btn_create"
                                onClick={CreateMint}
                            >
                                Mint NFT
                            </button>
                            <ToastContainer position="bottom-right" />
                        </div>
                    </div>
                </div>
            </div>
            {/* {loader} */}
        </div>
    );
};

export default DraftNFTDetails;
